<template>
	<div id='messagelist'>
		<div class="tabelMoreFzView main-mybody" style="overflow-y: auto; padding:0px;" :style="{height:($store.state.rolesdata.indexOf('khadmin1') >= 0 &&!aduit) || ($store.state.rolesdata.indexOf('khadmin3') >= 0 && !params.backend_edit) ?'18rem':'21rem' }">
			<div class="tabelMoreFzViewIn" style="padding:0.5rem 1.5rem 0.5rem">
				<div class="look_g" style="padding:0.55rem 0">
					<div></div>客戶資料
				</div>
				<div v-for="(item,ind) in moreFzOption" :key="ind + '1135'" style="display: inline-block;"
					:style="{width: ind==moreFzOption.length-3|| ind==moreFzOption.length-4 ?'100%' :'50%',left: ind==moreFzOption.length-3||ind==moreFzOption.length-4 ?'':ind%2== 0 ?'':'2%',
					position: 'relative'}">
					<div class="tabelMoreFzViewInList" v-if="$store.state.rolesdata.indexOf('khadmin2') >= 0||$store.state.rolesdata.indexOf('khadmin3') >= 0">
					    <div class="left" :style="{width:ind==moreFzOption.length-4|| ind==moreFzOption.length-3 ?'12%' :'24%' }" :class="ind==moreFzOption.length-4|| ind==moreFzOption.length-3 ? 'bjb_win1':'bjb_win2'">{{item.text}}：</div>
					    <div v-if='item.vs=="otcTrading"'  class="center" :style="{marginLeft:ind==moreFzOption.length-4|| ind==moreFzOption.length-3 ?'0' :'0',width:ind==moreFzOption.length-1 ?'':''}"><span v-if="item.value == 0">未簽署</span><span v-if="item.value == 1">已簽署</span><img src="@/image/heardright/copy.png" @click="fzEvent(item.value)"  style="height: 0.9rem;width: 0.9rem;display: inline-block;margin: 0 .5rem;"/></div>
					    <div v-else class="center" :style="{marginLeft:ind==moreFzOption.length-4|| ind==moreFzOption.length-3 ?'0' :'0',width:ind==moreFzOption.length-1 ?'91%':'',whiteSpace:ind==moreFzOption.length-4|| ind==moreFzOption.length-3 ?'normal' :'nowrap'}">{{item.value}}<img src="@/image/heardright/copy.png" @click="fzEvent(item.value)" 
						style="height: 0.9rem;width: 0.9rem;display: inline-block;margin: 0 .5rem;"/></div>
					</div>
					<div class="tabelMoreFzViewInList" v-else>
						<div class="left"  :class="ind==moreFzOption.length-4|| ind==moreFzOption.length-3 ? 'bjb_win1':'bjb_win2'" style="text-align: right;" :style="{width:ind==moreFzOption.length-3 || ind==moreFzOption.length-4 ?'12%' :'24%'}">{{item.text}}：</div>
						<div class="center"  v-if='ind == 0'>
							<!-- <span v-if='!item.isid'>{{item.value}}</span> -->
							<a-input  v-if='$store.state.rolesdata.indexOf("khadmin4") < 0&&!item.isid' class='myclasstop' v-model='item.value' style='color: #000000;' :disabled="true"></a-input>
							<div v-else style='display: inline-block;'>{{item.valmin}}
								<a-input v-model='isid' style='width: 50%;' :maxLength='3'></a-input>
								{{ item.valmin1 }}
								<img src="@/image/simu/save.png"
									style="height: 0.9rem;width: 0.9rem;display: inline-block;margin: 0 .5rem;"
									@click='handfrom(isid)' />
								<img src="@/image/quxiao.png" style="height: 0.9rem;width: 0.9rem;"
									@click="item.isid = !item.isid" />
							</div>
							<img v-if="$store.state.rolesdata.indexOf('khadmin4') >= 0&&!item.isid"
								src="@/image/heardright/edit.png" @click="item.isid = !item.isid" style="width: 1rem;height: 1rem;margin-left: .3rem;"/>
						</div>
						<div class="center" style="line-height: 1.5 !important;" v-if='ind > 0' :style="{width:ind==moreFzOption.length-3 || ind==moreFzOption.length-4?'88.4%' :''}">
							<!-- <span v-if='!item.isidet&&moreFzarr[ind].value' style="white-space: normal;">{{item.value}}</span> -->
							<span v-if='ind == 5' style="display: flex;align-items: center;">
								<div style="position: relative;width: 35%;margin-right: 4%;">
									<a-select v-model="item.value1" class="qhXz" style='width: 100%;' :disabled="aduit == 1" @change="qhclick">
										<a-select-option v-for="(item) in qhArr" :key="item.id" :label="'+ '+item.value"  :value="item.value">
											<!-- <span style="font-size:.8rem;float: left">{{ item.label }}</span> -->
											<span style="font-size:.8rem;" v-if="item.id !=11">+{{ item.value }}</span>
											<span style="font-size:.8rem;" v-else>{{ item.label }}</span>
										</a-select-option>
									</a-select>
									<div style="position: absolute;color: #606266;top: 4px;left:1px;height: 80%;display: flex;align-items: center;justify-content: center;
											width: 70%;background: #fff;border-radius: 4px;">
										<div v-if="!qhflag">+{{item.value1}}</div>
										<div class="qh_input" v-else style="display: flex;align-items: center;justify-content: center;">
										<div style="margin-left: 10px;font-size: 16px;">+</div>
										<a-input onkeyup="value=value=value.replace(/[^\d]/g,'')" :maxLength="3" v-model="item.value1"/>
										</div>
									</div>
								</div>
								<!-- <a-input v-model='item.value1' style='width: 30%;margin-right: 9%;padding: 4px;' 
								onkeyup="value=value.replace(/[^\d]/g,'')"></a-input> -->
								<a-input class='myclasstop' :style="{borderColor:border_col4?'red':''}" @input="border_col4 = false" v-model='item.value2' style='width: 60%;padding: 4px 11px;color: #000000;' :disabled="aduit == 1" onkeyup="value=value.replace(/[^\d]/g,'')"></a-input>
							</span>
							<a-select v-model="item.value" class="qhXz" style='width: 100%;'  :disabled="aduit == 1" v-else-if='item.vs=="otcTrading"'>
								<a-select-option :value="0">未簽署</a-select-option>
								<a-select-option :value="1">已簽署</a-select-option>
							</a-select>
							<a-input class='myclasstop' style='color: #000000;' :style="{borderColor:border_col5?'red':''}" @input="border_col5 = false" :disabled="aduit == 1" v-else-if='item.vs=="email"' v-model='item.value' @blur='emailfn(ind)'></a-input>
							<a-input class='myclasstop' style='color: #000000;' :style="{borderColor:border_col6?'red':''}" @input="border_col6 = false" :disabled="aduit == 1" v-else-if='item.vs=="id_number"' v-model='item.value' onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')"></a-input>
							<a-input class='myclasstop' style='color: #000000;' :style="{borderColor:border_col9?'red':''}" @input="border_col9 = false" :disabled="aduit == 1" v-else-if='item.vs=="bank_number"' v-model='item.value' onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')"></a-input>
							<a-input class='myclasstop' style='color: #000000;' :disabled="aduit == 1" v-else-if='item.vs=="cn_name"' v-model='item.value' onkeyup='value = value.replace(/[^\u4e00-\u9fa5]/g,"")'></a-input>
							<a-input class='myclasstop' style='color: #000000;' :style="{borderColor:border_col1?'red':''}" @input="border_col1 = false" :disabled="aduit == 1" v-else-if='item.vs=="en_name"' v-model='item.value' onkeyup='value=value.replace(/[^a-z A-Z]/g,"")'></a-input>
							<a-textarea class='myclasstop' style='color: #000000;' :style="{borderColor:border_col7?'red':''}" @input="border_col7 = false" :disabled="aduit == 1" v-else-if='item.vs=="address_en"' v-model='item.value' onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')" :auto-size="{ minRows: 2, maxRows: 2 }" :maxLength='130'></a-textarea>
							<a-textarea class='myclasstop' style='color: #000000;' :disabled="aduit == 1" v-else-if='item.vs=="address"' v-model='item.value' :auto-size="{ minRows: 2, maxRows: 2 }" :maxLength='130'></a-textarea>
							<a-input class='myclasstop' style='color: #000000;' :disabled="true" v-else-if='item.vs=="ipaddress"' v-model='item.value' ></a-input>
							<a-input class='myclasstop' style='color: #000000;' :disabled="true" v-else-if='item.vs=="country"' v-model='item.value' ></a-input>
							<a-input class='myclasstop' style='color: #000000;' :disabled="aduit == 1" v-else-if='item.vs=="nationality"' v-model='item.value' ></a-input>
							<a-input class='myclasstop' style='color: #000000;' :style="{borderColor:border_col3?'red':''}" @input="border_col3 = false" :disabled="aduit == 1" v-else-if='item.vs=="nationality_en"' onkeyup='value=value.replace(/[^a-z A-Z]/g,"")' v-model='item.value'></a-input>
							<a-input class='myclasstop' style='color: #000000;' :style="{borderColor:border_col10?'red':''}" onkeyup='value=value.replace(/[^a-z A-Z]/g,"")' @input="border_col10 = false" :disabled="aduit == 1" v-else-if='item.vs=="residential_nationality"' v-model='item.value' ></a-input>
							<a-input class='myclasstop' style='color: #000000;' :style="{borderColor:border_col8?'red':''}" @input="border_col8 = false" :disabled="aduit == 1" v-else-if='item.vs=="bank"' v-model='item.value' ></a-input>
							<a-input class='myclasstop' style='color: #000000;' :disabled="aduit == 1" v-else v-model='item.value' ></a-input>
							<!-- <img v-if="$store.state.rolesdata.indexOf('khadmin1') >= 0&&!item.isidet&&!aduit&&moreFzarr[ind].value"
								src="@/image/heardright/edit.png" @click="item.isidet = !item.isidet" style="width: 1rem;height: 1rem;margin-left: .3rem;"/> -->
						</div>
					</div>
				</div>
			
				<!-- <div class="tabelMoreFzViewInList" >
					<div class="left" style="text-align: right;" :style="{width:'12%'}" v-html='"網絡地址："'></div>
					
					<div class="center" :style="{marginLeft:'0',width:'43%'}">{{params.ipaddress}}<img v-if='false' src="@/image/heardright/copy.png" @click="fzEvent('ipaddress')" 
					style="height: 0.9rem;width: 0.9rem;display: inline-block;margin: 0 .5rem;"/></div>
					<div class="left" style="text-align: right;" :style="{width:'12%'}" v-html='"登入國家："'></div>
					
					<div class="center" :style="{marginLeft:'0',width:'38%'}">{{params.country}}<img v-if='false' src="@/image/heardright/copy.png" @click="fzEvent('country')" 
					style="height: 0.9rem;width: 0.9rem;display: inline-block;margin: 0 .5rem;"/></div>
					
				</div> -->
			</div>
			<!-- 签名查看 -->
			<!-- <div class="qianming_class" v-if="$store.state.rolesdata.indexOf('khadmin3') >= 0">
				<div style="padding:0.9rem 1.5rem 0.5rem">
					<div class="look_g1" style="padding:0.55rem 0">
						<div class="vertical_class"></div>簽署樣式
						<span>
							<el-image style="width: 20px; height: 22px;position: relative;top: 4px;margin-left: 10px;" :src="ck" :preview-src-list="[params.signature]" ></el-image>
						</span>
					</div>
				</div>
			</div> -->
			<!-- 開戶方式 -->
			<div class="yongjin_class" v-if="$store.state.rolesdata.indexOf('khadmin3') >= 0">
				<div style="padding:0.9rem 1.5rem">
					<div class="look_g" style="padding:0.55rem 0">
						<div></div>開戶方式
						<span >
							<img style="margin-bottom: 5px;width: 20px;margin-left: 10px;" src="../../../image/xg2.png" alt="" v-if="khFlag && !params.backend_edit" @click=" khFlag = !khFlag">
							<img style="margin-bottom: 5px;width: 20px;margin-left: 10px;" src="../../../image/xg1.png" alt="" v-if="!khFlag && !params.backend_edit"  @click=" khFlag = !khFlag">
						</span>
					</div>
					<div style="display: flex;align-items: center;width: 48.5%;">
						<div style="flex-shrink: 0;color: #000;font-size: 0.835rem;"  class="bjb_width">開戶方式：</div>
						<a-select v-model="params.khType" placeholder="請選擇開戶方式" style="width: 100%;" :disabled="$store.state.rolesdata.indexOf('khadmin3') < 0 || !khFlag">
							<a-select-option value="網上開戶">網上開戶</a-select-option>
							<!-- <a-select-option value="1">預約開戶</a-select-option> -->
							<a-select-option value="支票開戶">支票開戶</a-select-option>
						</a-select>
					</div>
				</div>
			</div>
			<!-- 香港佣金 -->
			<div class="yongjin_class">
				<div style="padding:0.9rem 1.5rem 0.5rem">
					<div class="look_g" style="padding:0.55rem 0">
						<div></div>佣金資料
						<span v-if="$store.state.rolesdata.indexOf('khadmin3') >= 0">
							<img style="margin-bottom: 5px;width: 20px;margin-left: 10px;" src="../../../image/xg2.png" alt="" v-if="houtaiFlag && !params.backend_edit" @click=" houtaiFlag = !houtaiFlag">
							<img style="margin-bottom: 5px;width: 20px;margin-left: 10px;" src="../../../image/xg1.png" alt="" v-if="!houtaiFlag && !params.backend_edit"  @click=" houtaiFlag = !houtaiFlag">
						</span>
					</div>
					<div class="text" style="position: relative; left: -14px;">香港證券交易</div>
					<div style="display:flex;">
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;"  class="bjb_width">非電子交易：</div>
							<a-input :oninput="params.non_hkd_ratio=params.non_hkd_ratio.replace(/[^\d.]/g, '')"  v-model="params.non_hkd_ratio" :disabled="$store.state.rolesdata.indexOf('khadmin3') < 0 || !houtaiFlag" suffix="%"></a-input>
						</div>
						<div style="width: 5%;"></div>
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;"  class="bjb_width">電子交易：</div>
							<a-input :oninput="params.hkd_ratio=params.hkd_ratio.replace(/[^\d.]/g, '')" v-model="params.hkd_ratio" :disabled="$store.state.rolesdata.indexOf('khadmin3') < 0 || !houtaiFlag" suffix="%"></a-input>
						</div>
					</div>
					<div class="text" style="position: relative; left: -14px;">最低交易收費</div>
					<div style="display:flex;">
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;"  class="bjb_width">非電子交易：</div>
							<a-input :oninput="params.non_hkd_min=params.non_hkd_min.replace(/[^\d.]/g, '')" v-model="params.non_hkd_min" :disabled="$store.state.rolesdata.indexOf('khadmin3') < 0 || !houtaiFlag" suffix="HKD"></a-input>
						</div>
						<div style="width: 5%;"></div>
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;"  class="bjb_width">電子交易：</div>
							<a-input :oninput="params.hkd_min=params.hkd_min.replace(/[^\d.]/g, '')" v-model="params.hkd_min" :disabled="$store.state.rolesdata.indexOf('khadmin3') < 0 || !houtaiFlag" suffix="HKD"></a-input>
						</div>
					</div>
				</div>
			</div>
			<!-- 美國佣金 -->
			<div class="yongjin_class">
				<div style="padding:0.55rem 1.5rem 0">
					<div class="text" style="position: relative; left: -14px;">美國證券交易</div>
					<div style="display:flex;">
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;"  class="bjb_width">非電子交易：</div>
							<a-input :oninput="params.non_us_ratio=params.non_us_ratio.replace(/[^\d.]/g, '')" v-model="params.non_us_ratio" :disabled="$store.state.rolesdata.indexOf('khadmin3') < 0 || !houtaiFlag" suffix="每股/USD"></a-input>
						</div>
						<div style="width: 5%;"></div>
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;"  class="bjb_width">電子交易：</div>
							<a-input :oninput="params.us_ratio=params.us_ratio.replace(/[^\d.]/g, '')" v-model="params.us_ratio" :disabled="$store.state.rolesdata.indexOf('khadmin3') < 0 || !houtaiFlag" suffix="每股/USD"></a-input>
						</div>
					</div>
					<div class="text" style="position: relative; left: -14px;">最低交易收費</div>
					<div style="display:flex;padding-bottom:0.7rem">
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;"  class="bjb_width">非電子交易：</div>
							<a-input :oninput="params.non_us_min=params.non_us_min.replace(/[^\d.]/g, '')" v-model="params.non_us_min" :disabled="$store.state.rolesdata.indexOf('khadmin3') < 0 || !houtaiFlag" suffix="USD"></a-input>
						</div>
						<div style="width: 5%;"></div>
						<div style="width: 100%;display:flex;align-items: center;" class="text">
							<div style="flex-shrink: 0;width:25%;text-align: right;" class="bjb_width">電子交易：</div>
							<a-input :oninput="params.us_min=params.us_min.replace(/[^\d.]/g, '')" v-model="params.us_min" :disabled="$store.state.rolesdata.indexOf('khadmin3') < 0 || !houtaiFlag" suffix="USD"></a-input>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
		</div>
		<div class='warp_daochu' v-if="$store.state.rolesdata.indexOf('khadmin1') >= 0 &&!aduit"> 
			<div style="padding-left: .5rem;"></div>
			<div>
				<button class='btn1 btnx' @click='resetForm("1")'>保存</button>
				<button class='btn1 btn2 bjb_sum' @click='resetForm("2")' style="margin-left: 60px;">提交</button>
			</div>
		</div>
		<div class='warp_daochu' v-if="$store.state.rolesdata.indexOf('khadmin3') >= 0 && !params.backend_edit"> 
			<div style="padding-left: .5rem;"></div>
			<div>
				<button class='btn1 btnx' @click='resetForm("1")'>保存</button>
				<button class='btn1 btn2 bjb_sum' @click='resetForm1()' style="margin-left: 60px;">提交</button>
			</div>
		</div>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	import ck from '../../../image/icon/sign_img.png';
	export default {
		props: ['record', 'forms','aduits'],
		components: {ck},
		data() {
			return {
				ck:ck,
				qhflag:false,
				khFlag:false,
				houtaiFlag:false,
				params:{
					signImg:['http://202.130.113.149:3785/kaihu/getPic?picname=852_1_0&pictype=identificationimage_HK&r=0.4561668369188384'],
				},
				border_col1:false,
				border_col2:false,
				border_col3:false,
				border_col4:false,
				border_col5:false,
				border_col6:false,
				border_col7:false,
				border_col8:false,
				border_col9:false,
				border_col10:false,
				qhArr:[
				    {id:'1',value: '86',label: '中國'}, 
				    {id:'2',value: '852',label: '中國香港'}, 
				    {id:'3',value: '853',label: '中國澳門'}, 
				    {id:'4',value: '61',label: '澳大利亞'}, 
				    // {id:'5',value: '1',label: '加拿大'},
				    {id:'6',value: '60',label: '馬來西亞'},
				    {id:'7',value: '1',label: '美國'},
				    {id:'8',value: '65',label: '新加坡'},
				    {id:'9',value: '64',label: '新西蘭'}, 
				    {id:'10',value: '44',label: '英國'},
				    {id:'11',value: '',label: '其他'}
				],
				aduit:'',
				isid: '',
				moreFzOption: [],
				moreFzarr: [],
				// khadmin4   最后審核人 只能修改 證券帳號       updateNewCode
				// 前跆 確認  除 證券帳號 都可以修改  保存接口   editNewJbxx
			}
		},
		mounted() {
			this.moreEvent()
			// console.log(this.$store.state.rolesdata.indexOf('khadmin1') >= 0,this.$store.state.rolesdata.indexOf('khadmin4') >= 0)
		},
		methods: {
			qhclick(val){
				if(!val){
					this.qhflag = true
				}else{
					this.qhflag = false
				}
			},
			emailfn(ind) {
				if (this.moreFzOption[ind].value) {
					var t = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
					if (!(t.test(this.moreFzOption[ind].value))) {
						this.moreFzOption[ind].value = ''
						this.$message.warning('請輸入正確的電郵地址')
					}
				}
			},
			substr(str, a, b) {
				return str.toString().substring(a, b)
			},
			resetForm1(){
				this.$ajax({
					method: 'post',
					url: this.$api.backendSubmit,
					data: {
						non_hkd_ratio : this.params.non_hkd_ratio,
						hkd_ratio : this.params.hkd_ratio,
						non_hkd_min : this.params.non_hkd_min,
						hkd_min : this.params.hkd_min,
						non_us_ratio : this.params.non_us_ratio,
						us_ratio : this.params.us_ratio,
						non_us_min : this.params.non_us_min,
						us_min : this.params.us_min,
						khType : this.params.khType,
						id : this.record.pdfcode
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						
						this.$message.success('操作成功')
						this.houtaiFlag = false;
						this.moreEvent()
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			resetForm(val) {
				console.log(this.forms);
				//都是必填项
				let obj = {}
				let str = ''
				if (val == 1) {
					console.log(this.moreFzOption,12124);
					this.moreFzOption.map((ev,ind) => {

						if(ind){
							if(this.moreFzOption[ind]['vs'] == 'otcTrading'){
								obj[ev.vs] = ev.value
							}else if(this.moreFzOption[ind]['vs'] == 'phonenum'){
								obj[ev.v1] = ev.value1
								obj[ev.vs] = ev.value2
								if(!ev.value1||!ev.value2){
									str = 1
								}
							}else{
								obj[ev.vs] = ev.value
								if(!ev.value && this.moreFzOption[ind]['vs'] != 'cn_name'&& this.moreFzOption[ind]['vs'] != 'address'&& this.moreFzOption[ind]['vs'] != 'nationality'&& this.moreFzOption[ind]['vs'] != 'bank'&& this.moreFzOption[ind]['vs'] != 'bank_number' && this.moreFzOption[ind]['vs'] != 'country' && this.moreFzOption[ind]['vs'] != 'ipaddress'){
									str = 1
								}
							}
						}
						if (ev.text == "英文名稱" && !ev.value) {
							this.border_col1 = true;
						}
						// if (ev.text == "國籍(中文)" && !ev.value) {
						// 	this.border_col2 = true;
						// }
						if (ev.text == "國籍(英文)" && !ev.value) {
							this.border_col3 = true;
						}
						if (ev.text == "電話號碼" && !ev.value2) {
							this.border_col4 = true;
						}
						if (ev.text == "電郵地址" && !ev.value) {
							this.border_col5 = true;
						}
						if (ev.text == "身份信息" && !ev.value) {
							this.border_col6 = true;
						}
						if (ev.text == "英文地址" && !ev.value) {
							this.border_col7 = true;
						}
						if (ev.text == "居住國家" && !ev.value) {
							this.border_col10 = true;
						}
					})
				}else{
					this.moreFzOption.map((ev,ind) => {
						if(ind){
							if(this.moreFzOption[ind]['vs'] == 'phonenum'){
								obj[ev.v1] = ev.value1
								obj[ev.vs] = ev.value2
								if(!ev.value1||!ev.value2){
									str = 1
								}
							}else{
								obj[ev.vs] = ev.value
								if(this.moreFzOption[ind]['vs'] == 'otcTrading'){
								}else{
									if(!ev.value && this.moreFzOption[ind]['vs'] != 'cn_name'&& this.moreFzOption[ind]['vs'] != 'address'&& this.moreFzOption[ind]['vs'] != 'nationality'&& this.moreFzOption[ind]['vs'] != 'country' && this.moreFzOption[ind]['vs'] != 'ipaddress'){
										str = 1
									}
								}
							}
							if (ev.text == "英文名稱" && !ev.value) {
							this.border_col1 = true;
							}
							// if (ev.text == "國籍(中文)" && !ev.value) {
							// 	this.border_col2 = true;
							// }
							if (ev.text == "國籍(英文)" && !ev.value) {
								this.border_col3 = true;
							}
							if (ev.text == "電話號碼" && !ev.value2) {
								this.border_col4 = true;
							}
							if (ev.text == "電郵地址" && !ev.value) {
								this.border_col5 = true;
							}
							if (ev.text == "身份信息" && !ev.value) {
								this.border_col6 = true;
							}
							if (ev.text == "英文地址" && !ev.value) {
								this.border_col7 = true;
							}
							if (ev.text == "銀行名稱" && !ev.value) {
								this.border_col8 = true;
							}
							if (ev.text == "銀行號碼" && !ev.value) {
								this.border_col9 = true;
							}
							if (ev.text == "居住國家" && !ev.value) {
								this.border_col10 = true;
							}
						}
					})
				}
				if(str  && this.$store.state.rolesdata.indexOf('khadmin3') < 0){
					this.$message.warning('請填寫數據')
					return
				}
				
				let url = '';
				url = val == 1 ? this.$api.newKhxxQt : this.$api.editNewJbxx;
				if(val == 1){
					obj.admintype = this.forms.admintype
				}
				obj.id = this.record.pdfcode
				obj.non_hkd_ratio = this.params.non_hkd_ratio
				obj.hkd_ratio = this.params.hkd_ratio
				obj.non_hkd_min = this.params.non_hkd_min
				obj.hkd_min = this.params.hkd_min
				obj.non_us_ratio = this.params.non_us_ratio
				obj.us_ratio = this.params.us_ratio
				obj.non_us_min = this.params.non_us_min
				obj.us_min = this.params.us_min
				obj.khType = this.params.khType
				// console.log(url,obj)
				obj.token = this.$store.state.token
				this.$ajax({
					method: 'post',
					url: url,
					data: obj
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						
						this.$message.success('操作成功')
						this.moreEvent()
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			handfrom(val) {
				if (val.length<3) {
					this.$message.warning("證券帳號必須輸入3位")
					return
				}
				this.$ajax({
					method: 'post',
					url: this.$api.updateNewCode,
					data: {
						token: this.$store.state.token,
						pdfcode: this.record.pdfcode,
						newcode: this.substr(this.moreFzOption[0].value, 0, 2) + this.isid + this.substr(this.moreFzOption[0].value, 5, 7)
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.$message.success('操作成功')
						this.moreEvent()
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			moreEvent(record = this.record) {
				let _this = this;
				//    if(record.schedule == 4 && record.status == 0 && !record.aduit){
				//        App.oTool.warningT("開戶審核已完成");
				//        return;
				//    }
				//    if(record.status == 2){
				//        App.oTool.warningT("開戶審核已取消");
				//        return;
				//    }
				// if(record.websiteflag != 0 && record.finishflag ==1 &&_this.form.admintype =='khadmin1'){
				//     App.oTool.warningT("沒有可用操作");
				//     return;
				// }

				if (!record.moreShowBol) {
					let json = {
						token: _this.$store.state.token,
					}
					https.fetchPost(_this.$api.getOpeningInfo, {
						id: record.pdfcode
					}, json).then((data) => {
						if (Object.is(data.qmiscode, 1000)) {
							let str = data.khid + '';
							this.params = data
							this.aduit = data.aduit
							this.moreFzOption = [{
									text: '證券帳號',
									value: data.khid,
									valmin:str.substr(0,2),
									valmin1:str.substr(5,7),
									vs: 'khid',
									isid: false
								},
								{
									text: '中文名稱',
									value: data.cn_name,
									vs: 'cn_name',
									isidet: false
								},
								{
									text: '英文名稱',
									value: data.en_name,
									vs: 'en_name',
									isidet: false
								},
								{
									text: '國籍(中文)',
									value: data.nationality,
									vs: 'nationality',
									isidet: false
								},
								{
									text: '國籍(英文)',
									value: data.nationality_en,
									vs: 'nationality_en',
									isidet: false
								},
								{
									text: '電話號碼',
									value: data.phonenum2,
									value1: data.nationcode,
									value2: data.phonenum,
									vs: 'phonenum',
									v1:'nationcode',
									isidet: false
								},
								{
									text: '電郵地址',
									value: data.email,
									vs: 'email',
									isidet: false
								},
								{
									text: '身份信息',
									value: data.id_number,
									vs: 'id_number',
									isidet: false
								},
								{
									text: '銀行名稱',
									value: data.bank,
									vs: 'bank',
									isidet: false
								},
								{
									text: '銀行號碼',
									value: data.bank_number,
									vs: 'bank_number',
									isidet: false
								},
								{
									text: '網絡地址',
									value: data.ipaddress,
									vs: 'ipaddress',
									isidet: false
								},
								{
									text: '登入國家',
									value: data.country,
									vs: 'country',
									isidet: false
								},
								{
									text: '通訊中文',
									value: data.address,
									vs: 'address',
									isidet: false
								},
								{
									text: '通訊英文',
									value: data.address_en,
									vs: 'address_en',
									isidet: false
								},
								{
									text: '居住國家',
									value: data.residential_nationality,
									vs: 'residential_nationality',
									isidet: false
								},
								{
									text: '場外交易',
									value: data.otcTrading,
									vs: 'otcTrading',
									isidet: false
								},
								// {
								// 	text: 'IP 地 址',
								// 	value: data.ipaddress,
								// 	vs: 'ipaddress',
								// 	// isidet: false
								// },
							];
							this.moreFzarr = JSON.parse(JSON.stringify(this.moreFzOption))
							console.log(this.moreFzarr);
						} else {
							App.oTool.warningT(data.qmismsg);
						}
					}).catch(err => {
						console.log(err);
					});
				} else {
					//二级弹窗
					_this.visible_bold = false;
					//关闭一级弹窗
					record.moreShowBol = false;
				}
			},

			fzEvent(value) {
				let clipboard = new this.$clipboard('img', {
				    text: function () {
				        return value
				    }
				})
				clipboard.on('success', e => {
				    App.oTool.successT('複製成功');
				    clipboard.destroy(e)
				})
				clipboard.on('error', e => {
				    App.oTool.warningT('複製失敗');
				    clipboard.destroy(e)
				})
			},
		}
	}
</script>
<style>
	.yongjin_class .ant-input[disabled]{
		color: #000;
	}
	@media screen and (min-width:2200px){
		.ant-calendar-picker-input, .ant-input{
			font-size: 0.835rem;
		}
		.ant-input-affix-wrapper .ant-input-suffix{
			font-size: 0.835rem;

		}
	
	}
</style>

<style scoped> 
	@media only screen and (max-width: 1024px) {
		.bjb_win1{
			width: 17% !important ;
		}
		.bjb_win2{
			width: 34% !important;
			height: 30px !important;
			display: flex;
			align-items: center;
			justify-content: right;
		}
		#messagelist .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .left{
			line-height: 30px !important;
		}
		.bjb_width{
			width: 35% !important;
		}
		.bjb_sum{
			margin-left: 10px !important;
		}
	
	}
    .qianming_class{
		border-top: 1px solid #e5e5e5;
	}
	.yongjin_class{
		border-top: 1px solid #e5e5e5;
	}
	.yongjin_class .text{
		font-size: 0.835rem;
		color:#000;
		padding: 0.55rem 0;
		
	}
	.look_g{
		font-size: 0.95rem;
		color: #000000;
		position: relative;
		left: -14px;
	}

	.look_g div{
		display: inline-block;
		width: 1px;
		height: 18px;
		position: relative;
		top: 0.1rem;
		margin-right: 0.5rem;
		border-left: 3px solid #0c8b97;
	}
	.look_g1{
		font-size: 0.95rem;
		color: #000000;
		position: relative;
		left: -14px;
	}
	
	.look_g1 .vertical_class{
		display: inline-block;
		width: 1px;
		height: 18px;
		position: relative;
		top: 0.1rem;
		margin-right: 0.5rem;
		border-left: 3px solid #0c8b97;
	}
	
	/* .myclasstop{
		position: relative;
		top: -.2rem;
	} */
	#messagelist .tabelMoreFzView .tabelMoreFzViewIn {
		background-color: #fff;
		padding: 0.7rem 0;
		border-radius: 4px;
		overflow: hidden;
	}

	#messagelist .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList {
		padding: 0.55rem 0;
		/* border-bottom: 1px #f3f3f3 solid; */
		display: flex;
		align-items: flex-start;
	}

	#messagelist .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList:last-child {
		border: none;
	}

	#messagelist .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .left {
		width: 24%;
		color: #000;
		font-size: 0.835rem;
		height: 1.7rem;
		line-height: 1.7rem !important;
	}

	#messagelist .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .center {
		font-size: 0.835rem;
		width: calc(72% - .3rem);
		color: #000;
		line-height: 1.7rem !important;
		white-space:nowrap;
		overflow:hidden;
		text-overflow:ellipsis;
	}

	#messagelist .center {
		/* height: 1.7rem;
		line-height: 1.7rem; */
	}

	#messagelist .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList img {
		width: 1.2rem;
		height: 1.2rem;
		margin: auto 0;
		margin-left: auto;
	}
	
</style>
